/* eslint-disable spire/export-styles */
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { useMergeStyles } from "@insite/content-library/additionalStyles";
import Hidden from "@insite/mobius/Hidden";
import getColor from "@insite/mobius/utilities/getColor";
import getContrastColor from "@insite/mobius/utilities/getContrastColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import injectCss from "@insite/mobius/utilities/injectCss";
import React, { FC } from "react";
import { connect } from "react-redux";
import styled, { css } from "styled-components";

const mapStateToProps = (state: ApplicationState) => ({
    enableWarehousePickup: getSettingsCollection(state).accountSettings.enableWarehousePickup,
});

type Props = WidgetProps & ReturnType<typeof mapStateToProps>;

const Navigation = styled.div`
    color: ${getContrastColor("common.accent")};
    font-size: .9375rem;
    padding-left: 1.5625rem;
    text-transform: uppercase;
    display: flex;
    justify-content: space-between;
    align-items: center;
    max-width: 1440px;
    margin: 0 auto;
    @media screen and (max-width: 1023px) and (min-width: 768px) {
      
    }
    @media screen and (max-width: 1080px) and (min-width: 1024px) {
        
    }
    @media (max-width: 991px) {
        padding-top: .3rem;
        padding-bottom: .3rem;
        padding-left: .9375rem;
    }

    > span {
        position: relative;
        right: 0;
    }
    > div {
        
        
        > span:last-child {
            @media screen and (max-width: 1080px) and (min-width: 1024px) {
                
                position: relative;
            }
        }
    }
    @media (max-width: 767px) {
        padding: 0;
        justify-content: flex-start;
        min-height: 2rem;
        height: 3rem;
        > span {
            left: 1rem;
            right: unset;
            top: -.7rem;
        }
    }
`;

const NavItem = styled.span<InjectableCss>`
    display: inline-flex;

    > span,
    > a {
        margin-left: .625rem;
    }
    ${injectCss}
`;

export interface SecondaryNavigationStyles {
    wrapper?: InjectableCss;
    languageLink?: InjectableCss;
    warehousePickupLink?: InjectableCss;
    signInLink?: InjectableCss;
    firstnav?: InjectableCss;
    PhoneNumber?: InjectableCss;  
}

export const secondaryNavigationStyles: SecondaryNavigationStyles = {
    languageLink: {
        css: css`
            flex: 0 0 auto;
            
        `,
    },
    warehousePickupLink: {
        css: css`
            flex: 0 1 auto;
            margin-left: 1.875rem;
            min-width: 0;
        `,
    },
    wrapper: {
        css: css`
            position: relavtive;
            left: 30%;
        `,
    },
    firstnav: {
        css: css`
            border-bottom: 2px solid #005cb9;
            background-color: ${getColor("common.background")};
                @media (max-width: 767px) {
                padding-top:.3rem;
                }
        `,
    },
    signInLink: {
        css: css`
            flex: 0 0 auto;
           
        `,
    },
    PhoneNumber: {
        css: css`
            flex: 0 0 auto;            
            display: inline-flex;
            text-transform: capitalize;
            background: #f0f2f5;
            margin: 0;
            padding: 1.2rem 1.5rem;
            align-items: center;
            line-height: 1rem;

            .phone-wrapper {
                padding: 0;
            }

            a {
                color: #002554 !important;
                font-family: "Roboto", sans-serif !important;
                font-size: .875rem !important;
                font-weight: bold;
                text-align: right;
                padding-left: .5rem;
                &:hover {
                    color: #2060ad !important;
                    text-decoration: underline;
                }
            }
        `,
    },
};

const SecondaryNavigation: FC<Props> = ({ id, enableWarehousePickup }) => {
    const styles = useMergeStyles("secondaryNavigation", secondaryNavigationStyles);

    return (
        <StyledWrapper {...styles.firstnav}>
            <Navigation {...styles.wrapper}>
                <NavItem>
                    <StyledWrapper>
                        <Zone contentId={id} zoneName="Logo" />
                    </StyledWrapper>
                </NavItem>
                <span id="nav-skip"></span>
                <Hidden below="lg">
                    <NavItem>
                        <Zone zoneName="Currency" contentId={id} fixed />
                    </NavItem>
                    <NavItem {...styles.languageLink}>
                        <Zone zoneName="Language" contentId={id} fixed />
                    </NavItem>
                    {enableWarehousePickup && (
                        <NavItem {...styles.warehousePickupLink}>
                            <Zone zoneName="ShipToAddress" contentId={id} fixed />
                        </NavItem>
                    )}
                    <NavItem {...styles.signInLink}>
                        <Zone zoneName="SignIn" contentId={id} fixed />
                    </NavItem>
                    <NavItem {...styles.PhoneNumber}>
                        <Zone zoneName="PhoneNumber" contentId={id} />
                    </NavItem>
                </Hidden>
            </Navigation>
        </StyledWrapper>
    );
};

const secondaryNavigation: WidgetModule = {
    component: connect(mapStateToProps)(SecondaryNavigation),
    definition: {
        group: "Common",
        icon: "NavigationList",
    },
};

export default secondaryNavigation;
